import {createPoint} from '@gaia/utils/gaia/createAreaPoint';
import {ampli} from '@gaia/utils/gaia/trackAnalytics';
import {boldTrackColors} from '@gaia/utils/gaia/trackColors';
import keyBy from 'lodash/keyBy';
import sample from 'lodash/sample';
import uniqueId from 'lodash/uniqueId';

export default function create(
    action: CreateAreaAction,
    setAreas: React.Dispatch<React.SetStateAction<{[localId: string]: Area}>>
) {
    ampli.createArea({category: 'map2'});

    const data = !action.data
        ? [createArea()]
        : (Array.isArray(action.data) ? action.data : [action.data]).map(createArea);

    setAreas((latestAreas) => ({
        ...latestAreas,
        ...keyBy(data, (area) => area.properties.localId),
    }));

    if (action.callback) {
        action.callback(data[0]);
    }

    return data.map((area: Area) => area.properties.localId);
}

export function createArea(area?: PartialArea): Area {
    const localId = uniqueId('area');

    const properties: AreaProperties = {
        color: sample(boldTrackColors),
        title: 'Untitled Area',
        time_created: new Date().toISOString(),
        ...area?.properties,
        localId,
        id: '',
        writable: true,
        archived: false,
        isLocallyCreated: true,
        type: 'area',
        track_type: 'polygon',
    };

    const isGeometryEditable =
        !area ||
        (area.geometry.coordinates.length === 1 && area.geometry.coordinates[0].length <= 100);

    const points = () => {
        if (area) {
            const copyCoordinates = [...area.geometry.coordinates[0]];
            // area geometry coordinates end where they start, the final coordinate should be omitted
            copyCoordinates.splice(-1);
            return keyBy(
                copyCoordinates.map((coordinate, index) => createPoint(coordinate, index, localId)),
                (point: AreaPoint) => point.properties.localId
            );
        }
        return {};
    };

    if (isGeometryEditable) {
        return {
            properties,
            isGeometryLoaded: true,
            isGeometryEditable: true,
            points: points(),
        };
    } else {
        return {
            properties,
            isGeometryLoaded: true,
            isGeometryEditable: false,
            geometry: area!.geometry,
        };
    }
}
